import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import { useFetchQuery } from "src/graphql/utils";
import { mapToOperator } from "src/mappers/operator.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

import { OperatorsQuery, OperatorsQueryVariables } from "../../__generated__/graphql";
import { operatorFragment } from "../../fragments/OperatorFragment";

const operatorsQuery = gql`
  query operators($dataType: DataType!) {
    allowedOperators(dataType: $dataType) {
      ...OperatorFragment
    }
  }
  ${operatorFragment}
` as TypedDocumentNode<OperatorsQuery, OperatorsQueryVariables>;

export const useGetOperatorsQuery = (
  options?: QueryHookOptions<OperatorsQuery, OperatorsQueryVariables>
) => {
  return useFetchQuery(operatorsQuery, {
    queryOptions: options,
    toData: (data) => data?.allowedOperators?.map(mapToOperator) ?? [],
    isEmpty: (data) => isEmpty(data?.allowedOperators),
    uiErrors: {
      fetchError: "FETCH-OPERATORS-ERROR",
      emptyError: "EMPTY-OPERATORS-ERROR",
    },
  });
};
